enum TenantWalletTransferType {
  TRANSFER = "transfer",
  REFUND = "refund"
}

export default TenantWalletTransferType
